//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsNavEditableTab",
  props: {
    isCurrentTab: {
      type: Boolean,
      required: true
    },
    segmentName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editing: false,
      newName: ""
    };
  },
  watch: {
    isCurrentTab(val) {
      if (!val) {
        this.setEditing(false);
      }
    }
  },
  methods: {
    setEditing(editing, name) {
      this.editing = editing;
      if (this.editing) {
        this.newName = cloneDeep(name);
      }
      this.$emit("editing", this.editing);
    },
    handleChangeName() {
      this.setEditing(false);
      this.$emit("change-name", this.newName);
    }
  }
});